var $ = jQuery
var custom = {};
var win = $(window);
var doc = $(document);
dosageCalculator = {
    defaults: {
      weightSelector: '[data-weight-selector]',
      pumpsSelector: '[data-pumps]',
      dosageSelector: '[data-dosage]',
      durationSelector: '[data-duration]',
      recommendation: '.recommendation-widget',
      submitBtn: '.submit-btn',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      loader: '[data-loader]',
      recommendedVariant: '',
      productLink: '[data-product-link]',
      selectedWeight: '',
      fieldGroupContainer: '.field-group-container',
      prodFieldGroupContainer: '.pdp-field-group-container',
      fieldGroup: '[data-field-group]',
      addPetBtn: '[data-add-pet]'
  
  
    },
    onInit: function() {
      const vm = dosageCalculator;
      const note = document.querySelector('.subscription-note')
  
  
      vm.displayFieldValue()
      vm.prodDisplayValues()
      vm.productLinkRedirect()
      vm.addPet()
      vm.handleQuantityControl()
      vm.onBottleSizeSelect()
      vm.removePet()
      vm.resetPets()
  
      vm.pdpAddPet()
      vm.pdpRemovePet()
      vm.pdpResetPets()
      //vm.handlePurchase()
  
      const handleLoadedElement = (mutationsList, observer) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if the addedNodes contains the element you are interested in
            const element = mutation.addedNodes[0]; // Assuming only one element is added at a time
            // Check if the element exists and has the properties you expect to identify it
            if (element && element.classList?.contains('rc-container-wrapper')) {
              document.querySelector('[data-radio-subsave]').addEventListener('click', e => {
                note.style.display = 'block';
              })
              document.querySelector('[data-radio-onetime]').addEventListener('click', e => {
                note.style.display = 'none';
              })
            }
          }
        });
      };
      
      // Select the element's parent node that the MutationObserver will watch for changes
      const parentElement = document.querySelector('.product-info');
      const observer = new MutationObserver(handleLoadedElement);
      // Configuration for the observer (we want to observe childList changes)
      const observerConfig = {
        childList: true,
        subtree: true, // Set to true if you want to observe all descendants as well
      };
      
      observer.observe(parentElement, observerConfig);
    },
  
    onLoad: e => {
      const vm = this;
    },
  
    onScroll: e => {
      const vm = this;
    },
  
    onResize: e => {
      const vm = this;
    },
  
    displayFieldValue: e => {
      const vm = dosageCalculator;
      const container = document.querySelector(vm.defaults.fieldGroupContainer)
  
      if (!container) {
        return false
      }
  
      container.addEventListener('change', evt => {

        if (evt.target && evt.target.nodeName === 'SELECT') {
          // Handle the change evt for the select field
  
          const select = evt.target
          const parent = select.closest('.field-group-row');
  
          let dosingObj = dosingChart.find(obj => obj.weight === select.value);
          vm.defaults.recommendedVariant = dosingObj.variant_id
    
          
          // Display corresponding `Pumps` based on selected weight
          const pumps = parent.querySelector(vm.defaults.pumpsSelector)
          pumps.value = dosingObj.pumps
    
    
          // Display corresponding `Dosage` based on selected weight
          const dose = parent.querySelector(vm.defaults.dosageSelector)
          dose.value = dosingObj.dose
    
          // Show recommendedation widget
          const recommendation = document.querySelector(vm.defaults.recommendation)
          if (recommendation.style.display == 'none') {
            recommendation.style.display = 'block'
          }
          
          const submit_btn = document.querySelector(vm.defaults.submitBtn)
          if (submit_btn.style.display == 'none') {
            submit_btn.style.display = 'block'
          }
  
          vm.computeDuration()
        }
      })
  
    },
  
    prodDisplayValues: e => {
      const vm = dosageCalculator;
      const container = document.querySelector(vm.defaults.prodFieldGroupContainer)
  
      if (!container) {
        return false
      }
  
      container.addEventListener('change', evt => {
  
        if (evt.target && evt.target.nodeName === 'SELECT') {
          // Handle the change evt for the select field
  
          const select = evt.target
          const parent = select.closest('.field-group-row');
  
          let dosingObj = dosingChart.find(obj => obj.weight === select.value);
          vm.defaults.recommendedVariant = dosingObj.variant_id
          
          // Display corresponding `Pumps` based on selected weight
          const pumps = document.querySelector(`[data-pumps][data-field-index="${select.parentNode.dataset.fieldIndex}"]`)
          pumps.value = dosingObj.pumps
    
    
          // Display corresponding `Dosage` based on .parentNodeed weight
          const dose = document.querySelector(`[data-dosage][data-field-index="${select.parentNode.dataset.fieldIndex}"]`)
          dose.value = dosingObj.dose
    
          // Show recommendedation widget
          const recommendation = document.querySelector(vm.defaults.recommendation)
          if (recommendation.style.display == 'none') {
            recommendation.style.display = 'block'
          }
          const submit_btn = document.querySelector(vm.defaults.submitBtn)
          if (submit_btn.style.display == 'none') {
            submit_btn.style.display = 'block'
          }
          var text_field_calculator = document.querySelectorAll('.text-field-calculator');
          text_field_calculator.forEach(function(element) {
            element.style.display = 'block';
          });
          if(dosingObj.bottle_size == 32 || dosingObj.bottle_size == '32'){
            if (document.body.classList.contains('template-product')) {
              document.getElementById('40482901557319').checked = true;
              document.getElementById('40621053935687').checked = false;
              document.getElementById('40482901524551').checked = false;
              document.getElementById('product-variant-id').value = '40482901557319';
            }
          } else if(dosingObj.bottle_size == 16 || dosingObj.bottle_size == '16'){
            if (document.body.classList.contains('template-product')) {
              document.getElementById('40482901557319').checked = false;
              document.getElementById('40621053935687').checked = false;
              document.getElementById('40482901524551').checked = true;
              document.getElementById('product-variant-id').value = '40482901524551';
            }
          } else {
            if (document.body.classList.contains('template-product')) {
              document.getElementById('40482901557319').checked = false;
              document.getElementById('40621053935687').checked = true;
              document.getElementById('40482901524551').checked = false;
              document.getElementById('product-variant-id').value = '40621053935687';
            }
          }
  
          vm.computeDuration()
        }
      })
  
    },
  
    handleQuantityControl: () => {
      const qty = document.querySelector('[data-quantity-input]')
  
      if (!qty) {
        return false
      }
  
      qty.addEventListener('change', e => {
        dosageCalculator.computeDuration()
      })
    },
  
    onBottleSizeSelect: () => {
      const radios = document.querySelectorAll('input[name="size"]');
      radios.forEach(radio => {
        radio.addEventListener('change', e => {
          setTimeout(e => {
            dosageCalculator.computeDuration()
          }, 100)
        })
      })
    },
  
    computeDuration: e => {
      const calculateFishOilDays = (V, ...dogs) => {
        // Convert bottle volume from ounces to milliliters
        const V_ml = V * 29.5735;
      
        // Calculate total daily consumption of fish oil in milliliters
        
        const total_daily_consumption_ml = (dogs[0] * 1) + (dogs[1] * 2) + (dogs[2] * 3) + (dogs[3] * 4) +
        (dogs[4] * 5) + (dogs[5] * 6) + (dogs[6] * 7);
      
        // Calculate number of days the bottle will last
        const d = Math.floor(V_ml / total_daily_consumption_ml);
      
        return d;
      };
  
      const vm = dosageCalculator;
      const selectors = document.querySelectorAll(vm.defaults.weightSelector)
      
      // Example usage
      const dogs = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // number of dogs in each weight category
      const V = parseInt(document.querySelector('input[name="size"]:checked').value); // bottle volume in ounces
      
  
      // Update dogs array based on number of pets and its weight
      selectors.forEach(selector => {
        var selectElement = selector.querySelector('select');
        dogs[selectElement.selectedIndex - 1] += 1
      })
  
      const days = calculateFishOilDays(V, ...dogs);
      const durationSelector = document.querySelector(vm.defaults.durationSelector)
  
      if (durationSelector) {
        const selector = document.querySelector('[data-quantity-input]')
        const quantity = selector ? parseInt(selector.value) : 1
        const duration = days * quantity
    
        vm.autoselectPlans(duration)
        vm.autoselectVolume(duration)
        if( duration != 'Infinity') {
          durationSelector.value = duration
        }
        vm.updateSubscriptionNote(duration);
      }
    },
  
    handleLoading: function(isLoading) {
      const vm = dosageCalculator;
      const addToCart = document.querySelector(vm.defaults.addToCart)
      const addToCartText = addToCart.querySelector(vm.defaults.addToCartText)
      const loader = addToCart.querySelector(vm.defaults.loader)
  
      if (isLoading) {
        addToCart.setAttribute('aria-disabled', true);
        addToCartText.classList.add('hide');
        loader.classList.remove('hide');
  
      } else {
        addToCart.removeAttribute('aria-disabled');
        addToCartText.classList.remove('hide');
        loader.classList.add('hide');
  
      }
    },
  
    addToCartItem: (params) => {
      const vm = dosageCalculator
      const buttonText = document.querySelector(dosageCalculator.defaults.addToCartText)
      
      $.ajax({
        method: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: params.quantity,
          id: params.id
        },
        dataType: 'json',
        async: false,
        beforeSend: function() {
          vm.handleLoading(true)
        },
        success: function() {
          setTimeout(() => {
            vm.handleLoading(false)
            buttonText.textContent = 'Added To Cart'
          }, 500)
        },
        error: function(response) {
          console.log('error', response)
        }
      });
    },
  
    handlePurchase: e => {
      const vm = dosageCalculator;
  
      const btn = document.querySelector(vm.defaults.addToCart)
      btn.addEventListener('click', e => {
        let quantity = document.getElementById('qty-control').value
        let id = vm.defaults.recommendedVariant
  
        vm.addToCartItem({
          quantity: quantity,
          id: id
        })
      })
    },
  
    productLinkRedirect: function() {
      const vm = dosageCalculator
      const productLink = document.querySelector(vm.defaults.productLink)
  
      if (!productLink) {
        return false
      }
  
      const pets = []
      
      productLink.addEventListener('click', e => {
        let dosingObj = dosingChart.find(obj => obj.weight === vm.defaults.selectedWeight);
        const quantity = document.querySelector('[data-quantity-input]').value
        const fieldGroup = document.querySelectorAll('.field-group-row')
  
        for (let i = 0; i < fieldGroup.length; i++) {
          const weight = fieldGroup[i].querySelector('[data-weight-selector]').value
          const pump = fieldGroup[i].querySelector('[data-pumps]').value
          const dosage = fieldGroup[i].querySelector('[data-dosage]').value
  
          pets.push(
            {
              'weight': weight,
              'pump': pump,
              'dosage': dosage
            }
          )
        }
  
        const jsonArrayString = JSON.stringify(pets);
        const encodedArray = encodeURIComponent(jsonArrayString);
        const selectedVolume = document.querySelector('.size-option input[type="radio"]:checked').value
        const url = `${document.location.origin}/products/stryde™-fish-oil?pets=${encodedArray}&qty=${quantity}&volume=${selectedVolume}` 
  
        window.location.href = url
      })
    },
  
    addPet: () => {
      const vm = dosageCalculator;
      const button = document.querySelector(vm.defaults.addPetBtn)
  
      if (!button) {
        return false
      }
  
      button.addEventListener('click', e => {
        let fieldGroups = document.querySelectorAll(vm.defaults.fieldGroup)
        let lastElement = fieldGroups[fieldGroups.length - 1] // Get the last element / copy of field group
        let clone = lastElement.cloneNode(true)
  
        clone.dataset.fieldGroup = parseInt(clone.dataset.fieldGroup) + 1
        clone.querySelectorAll('input[type="text"]').forEach(field => {
          field.value = ''
          field.dataset.fieldIndex = parseInt(field.dataset.fieldIndex) + 1
        })
  
        if (!clone.querySelector('button')) {
          const button = document.createElement('button')
          button.classList.add('btn', 'btn-secondary', 'btn-remove')
          clone.appendChild(button)
        }
  
        // Append to Field group container
        const container = document.querySelector(vm.defaults.fieldGroupContainer)
        container.appendChild(clone)
      })
    },
  
    pdpAddPet: e => {
      const vm = dosageCalculator;
      const button = document.querySelector('[data-pdp-add-pet]')
  
      if (!button) {
        return false
      }
  
      const container = document.querySelector(vm.defaults.prodFieldGroupContainer)
  
      const cloneInput = () => {
        const fieldOptions = container.querySelectorAll('.form-option.input')
  
        fieldOptions.forEach(option => {
          let field = option.querySelectorAll('input')
          let last = field[field.length - 1]
          let clone = last.cloneNode(true)
  
          clone.dataset.fieldIndex = parseInt(clone.dataset.fieldIndex) + 1
          clone.value = ''
  
          if ("pumps" in clone.dataset) {
            let index = parseInt(last.dataset.fieldIndex) + 1
  
            const button = document.createElement('a')
            button.classList.add('btn', 'btn-secondary', 'pdp-btn-remove')
  
            const wrapper = document.createElement('div')
            wrapper.classList.add('field-wrapper')
            wrapper.dataset.fieldIndex = index
  
            option.appendChild(wrapper)
  
            button.dataset.fieldIndex = index
            button.classList.add('btn-remove')
  
            wrapper.appendChild(button)
            wrapper.appendChild(clone)
  
          } else {
            option.appendChild(clone)
          }
  
        })
      }
  
      const cloneSelect = () => {
        const field = container.querySelectorAll('.select-option')
        let last = field[field.length - 1]
        let clone = last.cloneNode(true)
  
        clone.dataset.fieldIndex = parseInt(clone.dataset.fieldIndex) + 1
        clone.value = ''
  
        const parent = last.parentNode
        parent.appendChild(clone)
      }
  
      button.addEventListener('click', e => {
        e.preventDefault();
        cloneSelect()
        cloneInput()
      })
    },
  
    removePet: e => {
      const vm = dosageCalculator
      const container = document.querySelector(vm.defaults.fieldGroupContainer)
  
      if (!container) {
        return false
      }
  
      container.addEventListener('click', e => {
        if (e.target.classList.contains('btn-remove')) {
          const item = e.target.closest('.field-group-row')
          item.parentNode.removeChild(item)  
          vm.computeDuration()
        }
      })
    },
  
    pdpRemovePet: e => {
      const vm = dosageCalculator
      const container = document.querySelector(vm.defaults.prodFieldGroupContainer)
  
      if (!container) {
        return false
      }
  
      container.addEventListener('click', e => {
        if (e.target.classList.contains('pdp-btn-remove')) {
          const i = e.target.dataset.fieldIndex
          
          const weight = document.querySelector(`[data-weight-selector][data-field-index="${i}"]`)
          weight.remove()
  
          const button = document.querySelector(`.field-wrapper[data-field-index="${i}"]`)
          button.remove()
  
          const dosage = document.querySelector(`[data-dosage][data-field-index="${i}"]`)
          dosage.remove()
          
          vm.computeDuration()
        } 
      })
  
    },
  
    resetPets: e => {
      const vm = dosageCalculator 
      const button = document.querySelector('[data-button-reset]')
  
      if (!button) {
        return false
      }
  
      button.addEventListener('click', e => {
        const fieldGroup = document.querySelectorAll(vm.defaults.fieldGroup)
        for (let i = 1; i < fieldGroup.length; i++) {
          fieldGroup[i].parentNode.removeChild(fieldGroup[i])
        }
        vm.computeDuration()
      })
    },
  
    pdpResetPets: e => {
      const vm = dosageCalculator 
      const button = document.querySelector('[data-pdp-reset]')
      
      if (!button) {
        return false
      }
  
      button.addEventListener('click', e => {
        const select = document.querySelectorAll(vm.defaults.weightSelector);
        console.log(select);
        for (let i = 2; i <= select.length; i++) {
          const weight = document.querySelector(`[data-weight-selector][data-field-index="${i}"]`)
          weight.remove()
  
          const button = document.querySelector(`.field-wrapper[data-field-index="${i}"]`)
          button.remove()
  
          const dosage = document.querySelector(`[data-dosage][data-field-index="${i}"]`)
          dosage.remove()
          
        }
        vm.computeDuration()
      })
    },
  
    autoselectPlans: duration => {
      const plans = document.querySelector('[data-plans-dropdown]')
  
      if (!plans) {
        return false
      }
  
  
      const recommendSubscription = (d) => {
        switch (true) {
          case (d >= 0 && d <= 34):
            return 34;
          case (d >= 35 && d <= 41):
            return 41;
          case (d >= 42 && d <= 48):
            return 48;
          case (d >= 49 && d <= 55):
            return 55;
          case (d >= 56 && d <= 62):
            return 62;
          case (d >= 63 && d <= 69):
            return 69;
          case (d >= 70 && d <= 76):
            return 76;
          case (d >= 77 && d <= 83):
            return 83;
          case (d >= 84):
            return 90;
          default:
            return 90;
        }
      }
  
      let option = plans.querySelector(`option[data-plan-option*="${recommendSubscription(duration)}"]`).value
      plans.value = option
  
      // dosageCalculator.updateSubscriptionNote(recommendSubscription(duration))
    },
  
    updateSubscriptionNote: duration => {
      const note = document.querySelector('.subscription-note')
  
      if (!note) {
        return false
      }
  
      note.textContent = `Save 10% off. Receive a bottle 7 days before ${(duration)} days`
      // note.textContent = `Save 10% off. Receive a bottle 7 days before ${(duration + 7)} days`
    },
  
    autoselectVolume: duration => {
      const volumes = document.querySelectorAll('input[type="radio"][name="size"]')
  
      if (!volumes) {
        return false
      }
  
      const subs = document.querySelector(`input[data-radio-subsave]`)
      if (subs && subs.checked) {
  
      
        if (duration < 30) {
          const radio1 = document.querySelector(`input[name="size"][value*="8"]`)
          const radio2 = document.querySelector(`input[name="size"][value*="16"]`)
          const radio3 = document.querySelector(`input[name="size"][value*="32"]`)
  
          if ((duration * 2) >= 30) {
            if (radio1.checked) {
              console.log('radio 1 checked', duration * 2)
              radio2.click()
              radio2.checked = true
            } else if (radio2.checked) {
              console.log('radio 2 checked', duration * 2)
              radio3.click()
              radio3.checked = true
            }
          } else {
            radio3.click()
            radio3.checked = true
          }
        } 
      } 
    },
  
    toggleShellText: duration => {
      const text = document.querySelector('.duration-column .prompt')
  
      if (!text) {
        return false
      }
  
      text.style.display = duration >= 90 ? 'block' : 'none'
    },
  
  };
  $(window).ready(function() {
    dosageCalculator.onInit();
  });
  
  $(document).on('load', function() {
    dosageCalculator.onLoad();
  });
  
  $(document).resize(function() {
    dosageCalculator.onResize();
  });
  
  $(document).scroll(function() {
    dosageCalculator.onScroll()
  })